import React, { useEffect, useState } from "react";
import {
  CancelButton,
  UpdateButton,
} from "../../../components/mui/Buttons/Buttons";
import { Form, FormikProvider, useFormik } from "formik";
import { Box, MenuItem, Stack, TextField } from "@mui/material";
import GlobalDialog from "../../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../../components/mui/GlobalSelectField";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import {
  getAllBrands,
  updateBrand,
} from "../../../redux/features/assetManagementSlice";
import dayjs from "dayjs";
import {
  getSessionPreferences,
  updatesessionpreference,
} from "../../../redux/features/croSlice";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";

const EditSessionPreference = ({ rowData, data }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading } = useSelector((state) => state.cro);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      subject_enrollment_id: rowData.subject_enrollment_id,
      id: rowData.id,
      week_day: rowData.week_day ?? "", // fallback to empty
      from_time: rowData.from_time
        ? dayjs(rowData.from_time, "HH:mm:ss")
        : null,
      to_time: rowData.to_time ? dayjs(rowData.to_time, "HH:mm:ss") : null,
    },
    onSubmit: (values) => {
      const payload = {
        ...values,
        from_time: values.from_time
          ? dayjs(values.from_time).format("HH:mm:ss")
          : null,
        to_time: values.to_time
          ? dayjs(values.to_time).format("HH:mm:ss")
          : null,
      };

      dispatch(updatesessionpreference({ data: [payload] })).then((res) => {
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, { variant: "success" });
          dispatch(getSessionPreferences(data));
          setOpen(false);
        } else {
          enqueueSnackbar(res.payload.message, { variant: "error" });
        }
      });
    },
  });

  const weekdays = [
    { id: 0, day: "Sunday" },
    { id: 1, day: "Monday" },
    { id: 2, day: "Tuesday" },
    { id: 3, day: "Wednesday" },
    { id: 4, day: "Thursday" },
    { id: 5, day: "Friday" },
    { id: 6, day: "Saturday" },
  ];

  return (
    <GlobalDialog
      title={"Update Session Preference"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"sm"}
      closeButton={true}
      popupButton={
        <UpdateButton size="medium" action={() => setOpen(true)}>
          Update
        </UpdateButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    label="Weekday"
                    name="week_day"
                    value={formik.values.week_day}
                    onChange={formik.handleChange}
                  >
                    {weekdays.map((day) => (
                      <MenuItem key={day.id} value={day.id}>
                        {day.day}
                      </MenuItem>
                    ))}
                  </TextField>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      name="from_time"
                      label="From Time"
                      value={formik.values.from_time}
                      onChange={(newValue) =>
                        formik.setFieldValue("from_time", newValue)
                      }
                      onBlur={() => formik.setFieldTouched("from_time", true)}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          onKeyDown: (e) => e.preventDefault(),
                          error:
                            formik.touched.from_time &&
                            Boolean(formik.errors.from_time),
                          helperText:
                            formik.touched.from_time && formik.errors.from_time,
                        },
                      }}
                    />
                  </LocalizationProvider>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      name="to_time"
                      label="To Time"
                      value={formik.values.to_time}
                      onChange={(newValue) =>
                        formik.setFieldValue("to_time", newValue)
                      }
                      onBlur={() => formik.setFieldTouched("to_time", true)}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          onKeyDown: (e) => e.preventDefault(),
                          error:
                            formik.touched.to_time &&
                            Boolean(formik.errors.to_time),
                          helperText:
                            formik.touched.to_time && formik.errors.to_time,
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <UpdateButton disabled={loading} size="small" type="submit">
                      {loading ? "Please wait..." : "Update"}
                    </UpdateButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default EditSessionPreference;
